import ConfirmItemType1 from "./confirmItemType1";

export default ConfirmItemType1;
